import React from "react"
import Instagram from "../assets/instagram.svg"
import Twitter from "../assets/twitter-square.svg"
import LinkedIn from "../assets/linkedin.svg"
import Email from "../assets/email.svg"
import NewsletterForm from "./NewsletterForm"
import {
  ConnectBackgroundContainer,
  ConnectContainer,
  ConnectIconsContainer,
  ConnectLink,
} from "./styles"

const Connect = () => (
  <ConnectContainer>
    <ConnectBackgroundContainer />
    <NewsletterForm />
    <ConnectIconsContainer>
      <ConnectLink
        href="https://www.instagram.com/anumitha.apollo/"
        target="_blank"
        rel="noopener"
        aria-label="Instagram"
      >
        <Instagram height={60} width={80} />
      </ConnectLink>
      <ConnectLink
        href="https://twitter.com/ApolloAnumitha"
        target="_blank"
        rel="noopener"
        aria-label="Twitter"
      >
        <Twitter height={60} width={80} />
      </ConnectLink>
      <ConnectLink
        href="https://www.linkedin.com/in/anumitha-apollo-393b3a1a6/"
        target="_blank"
        rel="noopener"
        aria-label="Linkedin"
      >
        <LinkedIn height={60} width={80} />
      </ConnectLink>
      <ConnectLink
        href="mailto:anumithaapollo12@gmail.com"
        target="_blank"
        rel="noopener"
        aria-label="E-mail"
      >
        <Email height={60} width={80} />
      </ConnectLink>
    </ConnectIconsContainer>
  </ConnectContainer>
)

export default Connect
